<template>
  <!-- Splash while Firebase confirms auth state (~100ms) -->
  <div
    v-if="!authStore.isAuthReady"
    class="splash"
  >
    <img src="./assets/segura-logotype_deep-green.svg" class="splash-logo" alt="Segura Watch" />
  </div>

  <router-view v-else />
</template>

<script setup>
import { useAuthStore } from "./stores/authStore";
const authStore = useAuthStore();
</script>

<style>
@keyframes spin { to { transform: rotate(360deg); } }
.animate-spin   { animation: spin 0.8s linear infinite; }

.splash {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fdf8f1;
}
.splash-logo {
  height: 1.5rem;
  width: auto;
  opacity: 0.5;
}
</style>